import { CoreService } from "./../../services/coreService";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  Optional
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators,
  FormsModule
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
declare let toastr: any;

@Component({
    selector: "beneficiary-edit-modal",
    templateUrl: "./beneficiary-edit-modal.component.html",
    styleUrls: ["./beneficiary-edit-modal.component.scss"],
    providers: [CoreService],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class BeneficiaryEditModalComponent implements OnInit {
  form: UntypedFormGroup;
  attemptedSubmit = false;
  beneficiaries;
  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter<{ password: string; id: string }>();

  constructor(
    private builder: UntypedFormBuilder,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<BeneficiaryEditModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.builder.group({
      id: [null, [Validators.required]],
      title: [null, [Validators.required]]
    });
    this.form.controls.title.disable();
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.attemptedSubmit = false;
  }

  submitForm() {
    this.attemptedSubmit = true;
    if (this.form.valid) {
      this.submit.emit(this.form.value);
      this.dialogRef.close(this.form.value);
      this.resetModal();
    }
  }

  onChange() {
    this.form.controls["id"].value == null
      ? this.form.controls.title.disable()
      : this.form.controls.title.enable();
  }

  async ngOnInit() {
    try {
      this.beneficiaries = await this.coreService
        .GetBeneficiaries()
        .then(response => response.data);
    } catch (error) {
      toastr.error("", "Failed to fetch beneficiaries.", {
        timeOut: 2000
      });
      this.closeModal();
    }
  }
}
